<template>
  <div class="">
    <template v-if="generateMapFlag">

      <!-- <Map :geoJsonData="geoJsonData"/> -->
      <MapBoxMap :generateMapFlag="generateMapFlag" :geoJsonData="geoJsonData"/>
    </template>
    <!-- <div id="refreshButton" class="refreshButton">
      <b-button id="refreshBtn" size="sm" variant="outline-primary" @click="refreshMapData" style="height:75%; width:auto;"  class="form-control pt-0 pb-0 pr-1 pl-1">
        <i class="fas fa-redo-alt"></i>
      </b-button>
      <b-tooltip target="refreshBtn" title="Refresh" delay="0.5" triggers="hover" />
    </div> -->
  </div>
</template>

<script>
import Map from './PavementBody/Map.vue'
import MapBoxMap from './PavementBody/MapBoxMap.vue'
import {baseApiUrl} from '../../config.js'
import axios from 'axios'

export default {
  name: 'PavementBody',
  components: {
    Map,
    MapBoxMap
  },
  data(){
    return {
      generateMapFlag: false,
      geoJsonData: {}
    }
  },
  methods: {
    refreshMapData: function() {
      const current = this
      current.geoJsonData = {}
      current.generateMapFlag = false;
      this.fetchData().then((output)=>{
        current.geoJsonData = output
        current.generateMapFlag = true;
      }).catch(error=>{
        console.log(error);
      })
      // current.generateMapFlag = true;
    },
    fetchData: function() {
      return new Promise(function(resolve, reject) {
        let url = baseApiUrl + 'getGeoJsonData'
        axios.post(url).then(result=>{
          resolve(result.data)
        }).catch(error=>{
          reject(error)
        })
      });
    }
  },
  beforeMount() {
    this.refreshMapData();
  }
}
</script>

<style lang="css" scoped>
</style>
